import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "kn-list-item" }
const _hoisted_2 = { class: "kn-list-item-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Listbox = _resolveComponent("Listbox")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    style: _ctx.lovsManagementProfileAttributesListDescriptor.dialog.style,
    header: _ctx.$t('managers.lovsManagement.profileAttributes'),
    visible: _ctx.visible,
    modal: true,
    class: "p-fluid kn-dialog--toolbar--primary",
    closable: false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Listbox, {
        class: "kn-list",
        options: _ctx.profileAttributes,
        listStyle: _ctx.lovsManagementProfileAttributesListDescriptor.listBox.style,
        filter: true,
        filterPlaceholder: _ctx.$t('common.search'),
        optionLabel: "name",
        filterMatchMode: "contains",
        filterFields: _ctx.lovsManagementProfileAttributesListDescriptor.filterFields,
        emptyFilterMessage: _ctx.$t('common.info.noDataFound'),
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('selected', $event.value.attributeName)))
      }, {
        empty: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
        ]),
        option: _withCtx((slotProps) => [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("span", null, _toDisplayString(slotProps.option.attributeName), 1)
            ])
          ])
        ]),
        _: 1
      }, 8, ["options", "listStyle", "filterPlaceholder", "filterFields", "emptyFilterMessage"])
    ]),
    _: 1
  }, 8, ["style", "header", "visible"]))
}